import { Navbar, Container } from "react-bootstrap";
import ProfileDropdown from "../../../common/ProfileDropdown";
import "./Header.css";
import { useSchlStudentNotification } from "../../../context/StudentNotificationContext/SchlStudentNotificationContext";
import { useGetUnreadCount } from "../../../../hooks/organization/notification/useGetUnreadCount";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

const Header = ({ toggleSidebar, isCollapsed, isMobile }) => {
  const navigate = useNavigate(); // Initialize the navigate function
  const { unreadCount, setUnreadCount } = useSchlStudentNotification();
  const { getUnreadCount } = useGetUnreadCount();
  // We can pass the menu items we want to show in the dropdown with lable , link and icon
  const menuItems = [
    // { label: "Dashboard", link: "/teacher/dashboard", icon: "bi-house" },
    // { label: "Profile", link: "/teacher/profile", icon: "bi-person" },
  ];

  useEffect(() => {
    const fetchInitialCount = async () => {
      const count = await getUnreadCount();
      if (count !== null && count !== undefined) {
        setUnreadCount(count);
      }
    };

    fetchInitialCount();
  }, []);

  return (
    <Navbar
      className={`header ${isCollapsed && !isMobile ? "sidebar-collapsed" : ""}`}
      expand="lg"
    >
      <Container fluid>
        <div className="header-content">
          <button className="sidebar-toggle" onClick={toggleSidebar}>
            <i className="bi bi-list icon-style"></i>
          </button>
          <div className="navbar-header-right">
            <div
              className="notification-bell me-3 position-relative"
              style={{ cursor: "pointer" }}
              onClick={() => navigate("/teacher/reciever/notifications")}
            >
              <i className="fa-solid fa-bell" style={{ fontSize: "20px", color: "#ffffff" }}></i>
              {unreadCount > 0 && (
                <span
                  style={{
                    position: "absolute",
                    top: "-8px",
                    right: "-5px",
                    backgroundColor: "#0d6efd",
                    color: "white",
                    borderRadius: "50%",
                    padding: "2px 6px",
                    fontSize: "8px",
                  }}
                >
                  {unreadCount}
                </span>
              )}
            </div>
            <ProfileDropdown menuItems={menuItems} loginRedirectPath="/login" />
          </div>
        </div>
      </Container>
    </Navbar>
  );
};

export default Header;
